import FinalSalaryOption from "./finalSalaryOption";
import FinalSalarySchemeOptionsDetail from "@/guiide/ts/response/finalSalarySchemeOptionsDetail";
import { formatter } from "@/shared/ts/formatter";
import { FinalSalaryOptionsStatic } from "./finalSalaryOptionInfoStatic";
import { useUIContent } from "../../configuration/useUIContent";

type OptionInfo = { max: number, actual: number };

function createOptionInfo(max: number): OptionInfo {
    return { max, actual: 0 };
}

export default class TaxFreeCashModelSupporter {
    public options = new Array<FinalSalaryOption>();
    public max: number = 0;
    public optionsHaveDifferentMax: boolean = false;
    public selected: number = 0;
    public actual: Map<FinalSalaryOption, OptionInfo> = new Map<FinalSalaryOption, OptionInfo>();
    public activeOption: FinalSalaryOption = FinalSalaryOption.SchemeDefault;
    public activeMax: number = 0;
    public activeActual: number = 0;
    public step: number = 0;
    public sliderMax: number = 0;
    public ticks: number = 0;

    public setOptions(finalSalaryOptions: Array<FinalSalarySchemeOptionsDetail>, activeOption: FinalSalaryOption, taxFreeCashSliderInterval: number) {
        this.options = new Array<FinalSalaryOption>();
        this.activeOption = activeOption;

        for (const finalSalaryOption of finalSalaryOptions) {
            this.options.push(finalSalaryOption.type);
            this.optionsHaveDifferentMax = this.optionsHaveDifferentMax || finalSalaryOption.maxTaxFreeCash != finalSalaryOptions[0].maxTaxFreeCash;
            this.max = Math.max(this.max, finalSalaryOption.maxTaxFreeCash);
            this.step = taxFreeCashSliderInterval
            this.actual.set(finalSalaryOption.type, createOptionInfo(finalSalaryOption.maxTaxFreeCash));
        }

        this.setSliderProperties();

        this.changeActive(activeOption);
    }

    public refresh() {
        for (const option of this.options) {
            const optionInfo: OptionInfo = this.getOption(option);
            optionInfo.actual = this.selected > optionInfo.max ? optionInfo.max : this.selected;
        }

        this.changeActive(this.activeOption);
    }

    public changeActive(option: FinalSalaryOption) {
        this.activeOption = option;
        const optionInfo: OptionInfo = this.getOption(option);

        this.activeMax = optionInfo.max;
        this.activeActual = optionInfo.actual;
    }

    public getActual(finalSalaryOption: FinalSalaryOption): number | undefined {
        return this.getOption(finalSalaryOption).actual;
    }

    public getOption(option: FinalSalaryOption): OptionInfo {
        const actualOption = this.actual.get(option);

        if (!actualOption) {
            throw new Error('Missing option');
        }

        return actualOption;
    }

    public getOptionsDescription(finalSalaryOptionsStatic: FinalSalaryOptionsStatic): Array<string> {
        const { htmlArray } = useUIContent();

        const description = new Array<string>();
        const tfcOptionDetailToken = "{tfcOptionDetail}";

        for (const element of htmlArray('dboptions.modelling.tax-free-cash.help.body')) {
            if (element == tfcOptionDetailToken) {
                for (const option of this.actual) {
                    if (option[1].max == 0) {
                        continue;
                    }

                    const optionInfoStatic = finalSalaryOptionsStatic.get(option[0]);
                    const optionMax = formatter.formatCurrency(option[1].max);
                    description.push(`${optionInfoStatic.name}: ${optionMax}`);
                }
            }
            else {
                description.push(element);
            }
        }

        return description;
    }

    setSliderProperties() {
        this.sliderMax = 0;
        this.ticks = 1;

        if (this.step == 0 || (this.max / this.step) > 2000) {
            return;
        }

        do {
            this.sliderMax += this.step;
            this.ticks++;
        } while (this.sliderMax < this.max)
    }
}
